import { getCSRFToken } from '../lib/django';

const API_BASE = process.env.REACT_APP_API_BASE || "http://127.0.0.1:8000";

export async function getTodos() {
  const res = await fetch(`${API_BASE}/api/todos/`);
  if (!res.ok) throw new Error("Kunde inte hämta uppgifter");
  return await res.json();
}

export async function createTodo(payload) {
  const res = await fetch(`${API_BASE}/api/todos/`, {
    method: "POST",
    headers: { "Content-Type": "application/json", "X-CSRFToken": getCSRFToken() },
    body: JSON.stringify(payload),
  });
  if (!res.ok) throw new Error("Kunde inte skapa uppgift");
  return await res.json();
}

export async function updateTodo(id, patch) {
  const res = await fetch(`${API_BASE}/api/todos/${id}/`, {
    method: "PATCH",
    headers: { "Content-Type": "application/json", "X-CSRFToken": getCSRFToken() },
    body: JSON.stringify(patch),
  });
  if (!res.ok) throw new Error("Kunde inte uppdatera uppgift");
  return await res.json();
}

export async function deleteTodo(id) {
  const res = await fetch(`${API_BASE}/api/todos/${id}/`, {
    method: "DELETE",
    headers: { "X-CSRFToken": getCSRFToken() },
  });
  if (!res.ok) throw new Error("Kunde inte ta bort uppgift");
}
